// extracted by mini-css-extract-plugin
module.exports = {"announceButton":"AnnounceButton_announceButton__3_yf0","musicButton":"AnnounceButton_musicButton__3aSFs"};